/// <reference types="@angular/localize" />

import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { NgxsModule } from '@ngxs/store';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { ngxsImports } from './app/store/store';
import { JwtInterceptor } from './app/services/http/jwt.interceptors';
bootstrapApplication(AppComponent, {providers :  [ importProvidersFrom(HttpClientModule,NgxsModule,ngxsImports), provideHttpClient(withInterceptors([JwtInterceptor])) , provideRouter(routes) , provideIonicAngular(), provideIonicAngular({}), provideIonicAngular({})]})
  .catch((err) => console.error(err));
